import { miniSerializeError } from '@reduxjs/toolkit';
import ApiError from './ApiError';

const serializeError = (error) => {
  const json = miniSerializeError(error);

  if (error instanceof Error) {
    if (error.description) {
      try {
        json.description = JSON.stringify(error.description);
      } catch {
        // do nothing
      }
    }
  }

  if (error instanceof ApiError) {
    json.status = error.status;
    json.statusText = error.statusText;
  }

  if (error?.silent) {
    json.silent = error.silent;
  }

  return json;
};

export default serializeError;
